import React from 'react';
import { FilterDropdown } from '@components/common/FilterDropdown';
import { Checkbox } from '@fourthwall/components';
import { useFormik } from '@fourthwall/utils/dist/formik';
import * as S from './GiftCardsFilter.styled';
import { useFilterGiftCards } from './hooks/useFilterGiftCards';
const options = [
    { label: 'Unused', value: 'UNUSED' },
    { label: 'Fully used', value: 'FULLY_USED' },
    { label: 'Partially used', value: 'PARTIALLY_USED' },
    { label: 'Expired', value: 'EXPIRED' },
    { label: 'Deactivated', value: 'DEACTIVATED' },
];
export const GiftCardsFilter = () => {
    const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } = useFilterGiftCards();
    const hasStatusParam = (status) => {
        return !!filtersParams.status?.split(',').includes(status);
    };
    const handleSubmit = (values) => {
        const status = Object.keys(values)
            .filter((key) => values[key])
            .join(',');
        setFiltersParams({
            status,
        });
    };
    const formik = useFormik({
        initialValues: {
            UNUSED: hasStatusParam('UNUSED'),
            FULLY_USED: hasStatusParam('FULLY_USED'),
            PARTIALLY_USED: hasStatusParam('PARTIALLY_USED'),
            EXPIRED: hasStatusParam('EXPIRED'),
            DEACTIVATED: hasStatusParam('DEACTIVATED'),
        },
        enableReinitialize: true,
        onSubmit: handleSubmit,
    });
    const handleReset = () => {
        formik.resetForm();
        resetFiltersParams();
    };
    return (React.createElement(FilterDropdown, { content: React.createElement(S.Form, null,
            React.createElement(S.FormRow, null,
                React.createElement(FilterDropdown.GroupTitle, { title: "Status" }),
                options.map((option) => (React.createElement(Checkbox, { label: option.label, ...formik.getFieldProps(option.value) }))))), activityIndicator: hasFilterParams, onSubmit: formik.handleSubmit, onReset: handleReset }));
};
